import { computed } from 'vue';

import {
	InfoCircleOutlined,
	SoundOutlined,
	NodeIndexOutlined,
	DeploymentUnitOutlined,
	SlidersOutlined,
	ApartmentOutlined,
	RadarChartOutlined,
} from '@ant-design/icons-vue';

import BaselinesIcon from '@/components/menu/BaselinesIcon.vue';
import SatellitesIcon from '@/components/menu/SatellitesIcon.vue';
import { MAP_MODE } from '@/components/map/consts/mapFeatureConsts';
import { useLicenseStore } from '@/stores/licenseStore';

const MAP_MODES = [
	{ key: MAP_MODE.main, icon: InfoCircleOutlined },
	{ key: MAP_MODE.subNetworks, icon: ApartmentOutlined },
	{ key: MAP_MODE.gnss, icon: SatellitesIcon },
	{ key: MAP_MODE.gnssPerGridpoint, icon: SatellitesIcon },
	{ key: MAP_MODE.coverage, icon: RadarChartOutlined },
	{ key: MAP_MODE.snr, icon: SoundOutlined },
	{ key: MAP_MODE.multipath, icon: NodeIndexOutlined },
	{ key: MAP_MODE.residuals, icon: DeploymentUnitOutlined },
	{ key: MAP_MODE.paasStddev, icon: SlidersOutlined },
	{ key: MAP_MODE.baselines, icon: BaselinesIcon },
];

export const useAvailableMapModes = () => {
	const licenseStore = useLicenseStore();
	return computed(() => MAP_MODES.filter(mode => {
		if (mode.key === MAP_MODE.gnssPerGridpoint) {
			return licenseStore.allowPppGp;
		}
		if (mode.key === MAP_MODE.residuals) {
			return licenseStore.allowVrs || licenseStore.allowPppRtk;
		}
		if (mode.key === MAP_MODE.baselines) {
			return licenseStore.allowBaselines;
		}
		return true;
	}));
};
